import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getUnitWeight = createAsyncThunk(
  "admin/unit-weight",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/unit-weight", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getUnitWeightById = createAsyncThunk(
  "admin/unit-weight/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/unit-weight/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortUnitWeight = createAsyncThunk(
  "admin/unit-weight/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/unit-weight/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postUnitWeight = createAsyncThunk(
  "admin/unit-weight/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/unit-weight", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteUnitWeight = createAsyncThunk(
  "admin/unit-weight/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/unit-weight/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateUnitWeight = createAsyncThunk(
  "admin/unit-weight/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/unit-weight/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const unitWeightSlice = createSlice({
  name: "Unit Weight Store",
  initialState: initialState,
  reducers: {
    addUnitWeight(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortUnitWeight(state, action) {
      state.data.docs = action.payload;
    },
    deleteUnitWeight(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editUnitWeight(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getUnitWeight.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getUnitWeight.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getUnitWeight.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getUnitWeightById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getUnitWeightById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getUnitWeightById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortUnitWeight.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortUnitWeight.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortUnitWeight.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postUnitWeight.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postUnitWeight.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postUnitWeight.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteUnitWeight.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteUnitWeight.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteUnitWeight.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateUnitWeight.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateUnitWeight.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateUnitWeight.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const unitWeightActions = unitWeightSlice.actions;

export default unitWeightSlice.reducer;
